import React from 'react'

import { Box } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import Date from './Date'

const Dates = () => {
  return (
    <Box width="full" gap="s24">
      <Date title={i18n.t('contract_versions.flows.fix.steps.dates.effective_date.label')} />
      <Date title={i18n.t('contract_versions.flows.fix.steps.dates.start_date.label')} />
    </Box>
  )
}

export default Dates
